import { ExtraBold, SemiBold } from "../../utils";

export const GetSupportDetailedStyle ={
    root: {
        padding: "16px",
        width: '100%',
        overflow: "auto",
        backgroundColor:'#F8F8F8',
        height: 'calc(100vh - 65px) !important',
        // height: {
        //   xs:'calc(100vh - 147px)',
        //   sm:'calc(100vh - 155px)'
        // },
        "&::-webkit-scrollbar": {
          display: "none",
        },     
        md: {
            height: 'calc(100vh - 147px)',
        },
        
        
      },
      container:{
        paddingLeft:"0px !important",
        paddingRight:"0px !important",
      },
      headAvatar:{
        display:"flex",
        justifyContent:"center",
        margin:"0 auto",
      },
      headTitle:{
        color:"text.main",
        fontSize: "0.78125",
        fontFamily:ExtraBold,
        textAlign:"center",
        marginBottom:"24px"

      },
      likeText:{
        color:"text.secondary",
        marginTop:"32px",
        fontSize: "1rem",
        fontFamily:SemiBold,
        textAlign:"center"
      },
      likeIconsBox:{
        marginTop:"16px",
      },
      likeIcon:{
        backgroundColor:"#fff",
        borderRadius:"50%", 
        padding:"20px",
        boxShadow:"0px 3px 6px #00000029",
        cursor:"pointer",
        marginInlineStart: "16px"
      }
      
  
  }
  
  